import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { exceptionManagementFeature } from '@store';
import { DateFormatPipe, TeamMemberNamePipe } from '@shared/pipes';

@Component({
  templateUrl: './exception-history-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, DateFormatPipe, RktButtonDirective, TeamMemberNamePipe],
})
export class ExceptionHistoryModalComponent {
  activeModal = inject(ActiveModal);

  store = inject(Store);

  historyItems$ = this.store.select(exceptionManagementFeature.selectExceptionHistoryItems);
}
